import $ from 'jquery';
import { View } from 'backbone';
import _template from 'properties/table/column-main-checkbox.ejs';
import util     from 'util/Util.js';

// PF-5745
import undoService from 'UndoService';
import textConstants from 'TextConstants';

class MainColumnCheckboxView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;
        this.colId = this.model.get('selectedRowId');


        this.events = {
            'change input[type=checkbox]' : 'updateCheckAttributes'
        };
        if(this.colId){
            let factorykey=this.model.get('gridData')[this.colId].get('factoryKey');
            util.updateHelpDocumentationLink(factorykey);
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateCheckAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;
        const oldPropVal = this.model.get('gridData')[this.colId].attributes[propName];
        const colId = this.colId;

        this.model.get('gridData')[this.colId].attributes[propName] = propVal;

        undoService.add({
            undo: () =>{
                this.model.get('gridData')[colId].attributes[propName] = oldPropVal;
                this.render();
            },
            redo:() => {
                this.model.get('gridData')[colId].attributes[propName] = propVal;
                this.render();
            }
        }, textConstants.UNDO_MOVE);
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        let selected = util.isTrue(this.model.get('gridData')[this.colId].attributes['selected']);
        $(`input[name='selected']`).prop('checked', selected );

        this.delegateEvents();
        return this;
    }

}

export default MainColumnCheckboxView;
